import { QesColors } from "@app/shared/qes-standards/colors";
import { FC, useMemo } from "react";

interface ListItem {
  color: QesColors | string;
  label: string;
  value: number;
}

export interface ListLiteProps {
  items: ListItem[];
  sorted?: boolean;
}

export const MetricsListLite: FC<ListLiteProps> = (props: ListLiteProps) => {
  const { sorted = true } = props;
  const orderedList = useMemo(() => {
    if (!sorted) return props.items || [];
    return [...(props.items || [])].sort((a, b) => b.value - a.value);
  }, [props.items, sorted]);
  const longestLabelLength = useMemo(() => {
    let longest = 0;
    orderedList.forEach((item) => {
      longest = longest > item.label.length ? longest : item.label.length;
    });
    return longest;
  }, [props.items]);

  if (orderedList.length === 0) {
    return null;
  }

  const highestValue = Math.max(...orderedList.map((item) => item.value));
  const longestValueLength = highestValue.toLocaleString().length;

  return (
    <div className="metrics-list-lite__container">
      {orderedList.map((item) => {
        const percentWidth = (item.value / highestValue) * 100;
        return (
          <div className="metrics-list-lite__row" key={item.label}>
            <span className="metrics-list-lite__label" style={{ width: `${longestLabelLength * 1.2}ch` }}>{item.label}</span>
            <span className="metrics-list-lite__bar">
              <span className="metrics-list-lite__bar-value" style={{ backgroundColor: item.color, width: `${percentWidth}%` }}></span>
            </span>
            <span className="metrics-list-lite__value" style={{ width: `${longestValueLength * 1.2}ch` }}>{item.value.toLocaleString()}</span>
          </div>
        );
      })}
    </div>
  )
}
